import AppRoutes from './AppRoutes';
import { ZerezesServicesProvider } from './providers/ZerezesServicesProvider';
import { ZerezesGlobalStateProvider } from './providers/ZerezesGlobalStateProvider';

function App() {
  return (
    <ZerezesGlobalStateProvider>
      <ZerezesServicesProvider>
        <AppRoutes />
      </ZerezesServicesProvider>
    </ZerezesGlobalStateProvider>
  );
}

export default App;
